export const DELETED = '@attribute/DELETED';
